import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-3xl border border-slate-200 p-8 shadow-sm">
        <div className="w-14 h-14 mx-auto rounded-full bg-teal-100 text-teal-700 flex items-center justify-center">
          <KeyRound className="w-7 h-7" />
        </div>
        <h1 className="font-heading text-2xl font-extrabold mt-4 text-slate-900 text-center">Forgot password?</h1>
        {sent ? (
          <div className="mt-4 text-center text-slate-600 text-sm" data-testid="forgot-sent">
            If an account exists for <strong>{email}</strong>, we've sent a password reset link. Check your email (and spam folder).
            <div className="mt-6"><Link to="/login" className="font-semibold text-teal-700">Back to login</Link></div>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-4">
            <div>
              <Label htmlFor="email">Email Address</Label>
              <Input data-testid="forgot-email" id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" placeholder="you@example.com" required />
            </div>
            <Button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full h-11 bg-teal-600 hover:bg-teal-700 text-white rounded-full font-semibold">
              {loading ? "Sending..." : "Email me a reset link"}
            </Button>
            <p className="text-center text-sm text-slate-600">
              Remembered? <Link to="/login" className="font-semibold text-teal-700">Login</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
